import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { BuildingModel } from '@/api/models/building';
import { TenantModelWithContacts } from '@/api/models/tenant';
import { UnitModel } from '@/api/models/unit';
import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_Get_Resident = TenantModelWithContacts & {
  unit: UnitModel & {
    building: BuildingModel;
  };
};

const METHOD = 'GET';
const ENDPOINT = 'resident';
export const QUERY_KEY = () => getQueryKey(METHOD, ENDPOINT, {});

export const useGetResident = (enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(),
    queryFn: async () => {
      try {
        const data = await handleApiCall<ApiResponse_Get_Resident>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, {})
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch resident data.', { variant: 'error' });

        // eslint-disable-next-line no-console
        console.error(err);

        throw err;
      }
    },
  });
};
